import React from "react";
import { motion } from "framer-motion";
import { ENGINEERING_WORKFLOW } from "../../config/workflow";

/**
 * Visual engineering engagement workflow.
 */
export default function EngineeringWorkflow() {
  return (
    <section
      id="workflow"
      className="relative py-20 sm:py-28 lg:py-36 scroll-mt-[88px]"
      data-testid="engineering-workflow"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-6">
            <div className="sec-index mb-4">02B — Method</div>
            <h2 className="display display-section text-4xl md:text-6xl">
              How DEBSUN{" "}
              <span style={{ color: "var(--gold)" }}>works</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-base md:text-lg text-steel-text leading-relaxed">
              A disciplined engineering workflow — from consultation through
              commissioning and support. Clear stages. Clear accountability.
            </p>
          </div>
        </div>

        <div className="relative">
          <div
            className="hidden lg:block absolute left-0 right-0 top-[28px] h-px"
            style={{
              background:
                "linear-gradient(90deg, transparent, var(--gold), var(--teal), var(--gold), transparent)",
              opacity: 0.45,
            }}
            aria-hidden="true"
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {ENGINEERING_WORKFLOW.map((step, i) => (
              <motion.div
                key={step.id}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
                className="relative border border-border bg-secondary/30 p-6"
                data-testid={`workflow-step-${step.id}`}
              >
                <div className="flex items-center gap-3 mb-5">
                  <div
                    className="w-10 h-10 border border-[color:var(--gold)] flex items-center justify-center font-mono-2 text-[11px] tracking-[0.15em]"
                    style={{ color: "var(--gold)" }}
                  >
                    {String(step.step).padStart(2, "0")}
                  </div>
                  {i < ENGINEERING_WORKFLOW.length - 1 && (
                    <div
                      className="sm:hidden font-mono-2 text-[10px] tracking-[0.2em] uppercase text-muted-foreground"
                      aria-hidden="true"
                    >
                      ↓
                    </div>
                  )}
                </div>
                <h3 className="display display-section text-xl">{step.name}</h3>
                <p className="mt-3 text-sm text-steel-text leading-relaxed">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
